import { render } from "./DrugstoreGroupMembersModal.vue?vue&type=template&id=a8f9c5cc"
import script from "./DrugstoreGroupMembersModal.vue?vue&type=script&lang=js"
export * from "./DrugstoreGroupMembersModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__